import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CalendarEvents.css';

const API_KEY = 'AIzaSyCv4WyqIsDhWVzYVbDSafTb0obxWWaJe8E';
const CALENDAR_ID = 'mohit.eway@gmail.com';

function CalendarEvents() {
    const [weekEvents, setWeekEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            const now = new Date();
            const startOfWeek = new Date(now);
            startOfWeek.setDate(now.getDate() - now.getDay()); // Sunday

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 15);

            const url = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${API_KEY}&timeMin=${startOfWeek.toISOString()}&timeMax=${endOfWeek.toISOString()}&singleEvents=true&orderBy=startTime`;

            try {
                const res = await axios.get(url);
                setWeekEvents(res.data.items || []);
            } catch (error) {
                console.error('Failed to fetch week events', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, []);

    return (
        <div className="calendar-slider-container">
            <h2 className="section-title"><span role="img" aria-label="cow">📅</span> This Month's Events</h2>

            {loading ? (
                <p style={{ textAlign: 'center' }}>Loading events...</p>
            ) : weekEvents.length === 0 ? (
                <p style={{ textAlign: 'center', fontStyle: 'italic', color: '#999' }}>
                    No events scheduled this week.
                </p>
            ) : (
                <div className="weekly-event-grid">
                    {weekEvents.map(event => {
                        const startDate = new Date(event.start.dateTime || event.start.date);
                        const imageUrl = event.attachments?.[0]?.fileUrl || null;
                        const isToday = startDate.toDateString() === new Date().toDateString();

                        return (
                            <div
                                key={event.id}
                                className={`event-card ${isToday ? 'today-event' : ''}`}
                            >
                                {imageUrl && (
                                    <img src={imageUrl} alt="Event" className="event-image" />
                                )}
                                <h3 className="event-title">{event.summary}</h3>
                                <p className="event-date">🗓 {startDate.toLocaleDateString(undefined, {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}</p>
                                {event.description && (
                                    <p className="event-desc">{event.description}</p>
                                )}
                            </div>
                        );
                    })}

                </div>
            )}
        </div>
    );
}

export default CalendarEvents;
